import { render } from "./Invitacion.vue?vue&type=template&id=20c6aaf0&scoped=true"
import script from "./Invitacion.vue?vue&type=script&lang=js"
export * from "./Invitacion.vue?vue&type=script&lang=js"

import "./Invitacion.vue?vue&type=style&index=0&id=20c6aaf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c6aaf0"]])

export default __exports__